import { FORM_1099_ELIGIBLE_1099_REVIEW_COLUMN_OPTIONS } from "@common/helpers/close-template-task-view-config";
import { isEqual } from "@common/helpers/comparison";
import { CounterpartyDirectoryColumn } from "@common/types/views/counterpartyDirectoryView";

export { FORM_1099_ELIGIBLE_1099_REVIEW_COLUMN_OPTIONS };

export interface Form1099ColumnLike {
    id: string;
    options?: {
        customVariants?: Record<string, string>;
        pin?: "left" | "right";
        minSize?: number;
        maxSize?: number;
        size?: number;
    } | null;
}

export interface Form1099ViewLike {
    columns: Form1099ColumnLike[];
}

/**
 * Ensures the ELIGIBLE_1099 column uses the review variant. Applied at task
 * open so templates/tasks created before the review UI still get the sticky
 * review affordance without requiring a manual column reset.
 */
export function ensureForm1099Eligible1099ReviewColumn<
    T extends Form1099ViewLike,
>(view: T): T {
    let didChange = false;
    const columns = view.columns.map((column) => {
        if (column.id !== CounterpartyDirectoryColumn.ELIGIBLE_1099) {
            return column;
        }
        const nextOptions = {
            ...column.options,
            ...FORM_1099_ELIGIBLE_1099_REVIEW_COLUMN_OPTIONS,
            customVariants: {
                ...column.options?.customVariants,
                ...FORM_1099_ELIGIBLE_1099_REVIEW_COLUMN_OPTIONS.customVariants,
            },
        };
        if (isEqual(column.options ?? null, nextOptions)) {
            return column;
        }
        didChange = true;
        return { ...column, options: nextOptions };
    });
    return didChange ? { ...view, columns } : view;
}
